import { axios, createFormData, handleError } from '../axios';

export const updateContact = (data) => {
  return new Promise((resolve, reject) => {
    axios
      .post('admin/setting/contact', createFormData(data))
      .then((response) => {
        try {
          resolve(response.data);
        } catch (e) {
          console.error(e.message);
        }
      })
      .catch((e) => {
        handleError(e);
      });
  });
};
